import React from 'react';
import GeckoFieldBase from '../_base.jsx';

// This relies on the custom component supporting value and onChange, the onChange function can return an event from an input or the value itself
class GeckoFieldCustom extends GeckoFieldBase {
  render() {
    return React.cloneElement(this.field().component, {
      id: this.renderId(),
      placeholder: this.field().placeholder,
      className: `col-sm form-control gecko-ui-material ${
        this.field().component.props.className || ''
      }`,
      disabled: this.isDisabled(),
      value: this.value(),
      onChange: (val) => {
        if (val && val.target) {
          this.handleChange(val);
        } else {
          this.props.handler.bind(
            this,
            this.field().key,
            this.prepareValue(val)
          )();
        }
      },
    });
  }
}

export default GeckoFieldCustom;
